const flatParts = (groupedByArticleBrandParts) => {
    return groupedByArticleBrandParts
        .map((groupedByArticleBrandPart) => groupedByArticleBrandPart.parts)
        .flat()
}

export default flatParts
